import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { FaExclamationTriangle } from "react-icons/fa";

export default function EditAttendance({
  open,
  onClose,
  onConfirm,
  isCancel = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogContent className="px-2">
        <Box display="flex" alignItems="flex-start" gap={1.5}>
          <FaExclamationTriangle
            size={25}
            className={isCancel ? "text-danger" : "text-primary"}
          />
          <Box>
            <Typography
              variant="body1"
              gutterBottom
              fontWeight={500}
              className={isCancel ? "text-danger" : "text-primary"}
            >
              {isCancel
                ? "You are about to cancel attendance editing."
                : "You are about to enable attendance editing."}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {isCancel
                ? "Cancelling edit will lock attendance updates and prevent further modifications."
                : "Updating attendance may affect salary calculations and employee reports. Please proceed with caution."}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Close
        </Button>
        <Button
          variant="contained"
          color={isCancel ? "warning" : "error"}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {isCancel ? "Cancel Edit" : "Enable Edit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
